
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { map } from 'rxjs/operators';
import { ServiceResponse } from '@sdbn/common';
import { Identity } from '@sdbn/common';
import { AssignmentServiceResponse, AssignTransportToStation, AvailableTransports, AvailableTransportsSelection, CancellationStation, CancelTransport, DisableStationFetch, SendTransportToStation, SetProcessingStatus, SuspendStation, TransportStationAssignment } from "../model/sac-client.model";


@Injectable({
  providedIn: 'root'
})
export class SacClientService {

  constructor(
    private appServerAPI: AppServerAPI
  ) { }

  public loadAvailableTransports(selection: AvailableTransportsSelection): Observable<AvailableTransports> {
    return this.appServerAPI.execute<AvailableTransports>('/client/control/sac-client/available-transports', selection).pipe(
      map(
        at => {
          return new AvailableTransports(at);
      })
    );
  }

  public cancelTransport(action: CancelTransport): Observable<ServiceResponse> {
    const url = `/client/control/sac-client/cancel`;
    return this.appServerAPI.execute<ServiceResponse>(url, action);
  }

  public sendTransportToStation(action: SendTransportToStation): Observable<AssignmentServiceResponse> {
    const url = `/client/control/sac-client/send`;
    return this.appServerAPI.execute<AssignmentServiceResponse>(url, action).pipe(
      map(sr => new AssignmentServiceResponse(sr))
    );
  }

  public getStationsForCancellation(assignment: TransportStationAssignment): Observable<Array<CancellationStation>> {
    const url = `/client/control/sac-client/cancellation-stations`;
    return this.appServerAPI.execute<Array<CancellationStation>>(url, assignment).pipe(
      map(
        r => r.map(cs => new CancellationStation(cs))
      )
    );
  }

  public setProcessingStatus(request: SetProcessingStatus) {
    const url = `/client/control/sac-client/set-processing-status`;
    return this.appServerAPI.execute<ServiceResponse>(url, request);
  }

  public callTransportToStation(assignment: TransportStationAssignment): Observable<any> {
    const url = `/client/control/sac-client/call-transport`;
    return this.appServerAPI.execute<any[]>(url, assignment);
  }

  public suspendStation(action: SuspendStation): Observable<ServiceResponse> {
    const url = `/client/control/sac-client/suspend-station`;
    return this.appServerAPI.execute<ServiceResponse>(url, action);
  }

  public endStationSuspension(identity: Identity): Observable<ServiceResponse> {
    const url = `/client/control/sac-client/end-station-suspension`;
    return this.appServerAPI.execute<ServiceResponse>(url, identity);
  }

  public disableFetchUntilForStation(disableFetchAction: DisableStationFetch) {
    const url = `/client/control/sac-client/disable-station-fetch`;
    return this.appServerAPI.execute<ServiceResponse>(url, disableFetchAction);
  }

  public assignTransport(assignment: AssignTransportToStation) {
    return this.appServerAPI.execute<ServiceResponse>('/client/control/sac-client/assign-transport', assignment);
  }
}
